/**
 *
 * Global state to add an entity to SavaneJS and display the corresponding Node in Cocos (on frontView)
 *
 * @param id
 * @constructor
 */

import { AddEntityState, ActionState, ActionStateEnum, FrontViewState } from "..";
import { FrontViewManager } from "../../plan/FrontViewManager";
import { PlanManager } from "../../../../cocosPlan";
import { ArrangementGroup, ArrangementObject, Entity, math, TechnicalElement } from "@rhinov/savane-js";


export class FrontViewAddEntity extends AddEntityState {
    constructor(type: Entity, conf?: any, toClone?: boolean) {
        super(type, conf);
        PlanManager.getInstance().updateItemsSelected([this.entity], false, false);
        this.node.setSelected(false);
        this.state = ActionStateEnum.FrontViewAddEntity;
    }

    mouseClickUp(cursorPosition: math.vec3, elapsedTime: number, hoverEntities: Entity[], mouseButton: number): ActionState | null {
        //convert pos
        var pos = this.convertPos(cursorPosition);
        var state = super.mouseClickUp(pos, elapsedTime, hoverEntities, mouseButton) as AddEntityState;

        var newPosition = math.vec3.create();
        math.vec3.set(newPosition, this.entity.position[0], this.entity.position[1], pos[2]);
        this.entity.position = newPosition;

        state.entity = this.entity;

        PlanManager.getInstance().updateItemsSelected([this.entity], false, true);

        return state;
    }

    moveMouseCursor(cursorPosition: math.vec3, hoverEntities?: Entity[], planpos?: math.vec3): ActionState | null {
        if ((this.entity as ArrangementGroup | ArrangementObject).isAnchorActive) {
            (this.entity as ArrangementGroup | ArrangementObject).isAnchorActive = false;
        }
        //convert pos
        var pos = this.convertPos(cursorPosition);
        var state = super.moveMouseCursor(pos);

        var newPosition = math.vec3.create();
        math.vec3.set(newPosition, this.entity.position[0], this.entity.position[1], pos[2]);
        this.entity.position = newPosition;

        FrontViewManager.updateDecoration(this.entity, true);
        FrontViewManager.selectDecoration(this.entity);
        return state;
    }

    mouseClickCancelled(cursorPosition: math.vec3): ActionState | null {
        FrontViewManager.deleteDeco(this.entity);
        return super.mouseClickCancelled(this.convertPos(cursorPosition));
    }

    createIdleState(entity: Entity): ActionState {
        if (entity instanceof ArrangementObject || entity instanceof ArrangementGroup) {
            (this.entity as ArrangementGroup | ArrangementObject).isAnchorActive = true;
            return new FrontViewState(false);
        }
        else {
            return new FrontViewState(true);
        }
    }

    convertPos(cursorPosition: math.vec3): math.vec3 {
        var isDirectSide = PlanManager.getInstance().frontViewLayer.isDirectSide;
        var wall = PlanManager.getInstance().frontViewLayer.currentWall!;

        var pos = math.vec3.create();
        var entity = this.entity as TechnicalElement | ArrangementObject

        if (PlanManager.getInstance().frontViewLayer.isDirectSide) {
            math.vec3.set(pos,
                wall.begin[0] + cursorPosition[0] * wall.wallDirection[0] +
                (isDirectSide ? 1 : -1) * wall.wallDirection[1] * (wall.thickness / 2 + entity.width / 2),
                wall.begin[1] + cursorPosition[0] * wall.wallDirection[1] +
                (isDirectSide ? -1 : 1) * wall.wallDirection[0] * (wall.thickness / 2 + entity.width / 2),
                cursorPosition[2]);
        }
        else {
            math.vec3.set(pos,
                wall.begin[0] + (wall.length - cursorPosition[0]) * wall.wallDirection[0] +
                (isDirectSide ? 1 : -1) * wall.wallDirection[1] * (wall.thickness / 2 + entity.width / 2),
                wall.begin[1] + (wall.length - cursorPosition[0]) * wall.wallDirection[1] +
                (isDirectSide ? -1 : 1) * wall.wallDirection[0] * (wall.thickness / 2 + entity.width / 2),
                cursorPosition[2]);
        }

        return pos;
    }
}

